// extracted by mini-css-extract-plugin
export var newsListBanner = "newsBanner-module--newsListBanner--K8PQC";
export var newsListBanner__content = "newsBanner-module--newsListBanner__content--MJHBf";
export var newsListBanner__link = "newsBanner-module--newsListBanner__link--novmQ";
export var newsListBanner__main = "newsBanner-module--newsListBanner__main--rtOx9";
export var newsListBanner__title = "newsBanner-module--newsListBanner__title--UjyQJ";
export var newsListBanner__videoModal = "newsBanner-module--newsListBanner__videoModal--td2et";